module.exports = __webpack_public_path__ + "img/solution@2x.15d0ea75.png";